import React,{ useEffect,useState } from 'react';
const JsonResponseData =() => {
	const [jsonData, setJsonData] = useState([]);
	console.log("jsonData",jsonData);
	useEffect(() => {
		fetchJsonData();
	}, []);
	const fetchJsonData = () =>{
		let data = sessionStorage.getItem("responseData");
		setJsonData(JSON.stringify(data));
		// sessionStorage.removeItem("responseData");
	};
	return (
		<>
			<div><p>{jsonData}</p></div>
		</>
	);
};
export default JsonResponseData;